import { Dispatch, SetStateAction, createContext } from "react";

export type ICameraContext = {
    camera: MediaDeviceInfo | undefined,
    setCamera: Dispatch<SetStateAction<MediaDeviceInfo | undefined>>
}

const defaultVideoCallManager: ICameraContext = {
    camera: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCamera: () => {}
}

export const CameraContext = createContext<ICameraContext>(defaultVideoCallManager);
